import sortBy from 'lodash/sortBy'
import moment from 'moment-timezone'
import { Dataset, Folder, SortBy } from './types'

export function getFoldersFromDatasets(datasets: Dataset[]) {
  return datasets.reduce((folders: Folder[], dataset: Dataset) => {
    if (!dataset.folder) return folders

    if (!folders.find((folder: Folder) => folder.id === dataset.folderId)) {
      folders.push({ ...dataset.folder })
    }

    return folders
  }, [])
}

export function sortDatasets(newSortBy: SortBy, allDatasets: Dataset[]): Dataset[] {
  switch (newSortBy) {
    case SortBy.ALPHABETICAL_ASC: {
      const sorted = sortByName(allDatasets)
      return sorted
    }

    case SortBy.ALPHABETICAL_DESC: {
      const sorted = sortByName(allDatasets)
      return sorted.reverse()
    }

    default: {
      return allDatasets.sort(sortByMostRecent)
    }
  }

  function sortByName(datasets: Dataset[]): Dataset[] {
    return sortBy(datasets, (d: Dataset) => d.name)
  }

  function sortByMostRecent(a: Dataset, b: Dataset) {
    const mostRecentATimestamp = a.lastSubmissionTime ?? a.updatedAt ?? a.createdAt
    const mostRecentBTimestamp = b.lastSubmissionTime ?? b.updatedAt ?? b.createdAt

    return (
      moment.utc(mostRecentBTimestamp).local().valueOf() -
      moment.utc(mostRecentATimestamp).local().valueOf()
    )
  }
}
